import { string, object } from 'yup'

const validationSchema = object({
  project_title: string().trim().required().label('Project name'),
})

export default validationSchema
